<template>
  <div>
    <div class="card">
      <div class="card-header d-flex">
        <h5 class="mb-0">Detalles del Usuario {{ user.username }} ({{ user.collectiveName }})</h5>
        <button type="button" class="btn-close ms-auto" aria-label="Close" @click="$emit('close')"></button>
      </div>
      <div class="card-body">
        <dl class="row mb-0">
          <template v-for="(item, index) in tableData">
            <dt class="col-sm-4" :key="`key-${index}`">{{ item.key }}</dt>
            <dd class="col-sm-8" :key="`value-${index}`" v-html="item.value"></dd>
          </template>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import User from "@/models/user";
import { filters } from "@/filters/filters";

export default {
  name: 'user-details',
  props: {
    user: User
  },
  data() {
    return {
      tableData: [],
    };
  },
  watch: {
    user: {
      immediate: true,
      handler(newUser) {
        if (newUser) {
          this.initializeComponent();
        }
      }
    }
  },
  methods: {
    initializeComponent() {
      this.tableData = [];
      const requiredData = [
        { key: 'ID', value: this.user.id },
        { key: 'Username', value: this.user.username },
        { key: 'Colectivo', value: this.user.collectiveName }
      ];

      const optionalData = [
        { key: 'Nombre', value: this.user.name },
        { key: 'Apellidos', value: this.user.surname },
        { key: 'Email', value: this.user.email },
        { key: 'Teléfono', value: this.user.telephone },
        { key: 'Código postal', value: this.user.zipCode },
        { key: 'Token de registro', value: this.user.registerToken },
        { key: 'Id Sap', value: this.user.socialIdSap },
        { key: 'Fecha baja suscripción', value: this.user.unsubscribeDate }
      ];

      const lastRequiredData = [
        { key: 'Activo', value: filters.yesNo(this.user.active), html: true },
        { key: 'Fecha creación', value: this.user.createdAt ? filters.formatDateTime(this.user.createdAt) : null },
        { key: 'Fecha última modificación', value: this.user.createdAt ? filters.formatDateTime(this.user.createdAt) : null }
      ];

      for (const item of requiredData) {
        this.tableData.push(item);
      }
      for (const item of optionalData) {
        if (!item.value) {
          continue;
        }
        this.tableData.push(item);
      }
      for (const item of lastRequiredData) {
        this.tableData.push(item);
      }
    }
  }
}
</script>
